import { render, staticRenderFns } from "./DayCards.vue?vue&type=template&id=08a3f77e"
import script from "./DayCards.vue?vue&type=script&lang=js"
export * from "./DayCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports